import React from "react";
import moment from "moment";
import i18n from "../../i18n";

export function Directions({images}) {
  const names = {
    'scheme': i18n.t('components.tools.deliveryTools.directions.scheme'),
    'photo': i18n.t('components.tools.deliveryTools.directions.photo'),
  }

  if (images && images.length > 0) {
    return images.map((image, idx) => {
      var name = names[image.type]
      return <p key={idx} style={{margin: '0 0 4px 0', fontSize: '12px', lineHeight: '1.4'}}><a target="_blank" href={image.file}>{name}</a></p>;
    })
  } else {
    return <div/>;
  }
}
